export const FAVORITE_ADD = '/favorite/add';
export const FAVORITE_REMOVE = '/favorite/remove';
export const FAVORITE_MY = '/favorite/my';
export const FAVORITE_COUNT = '/favorite/count';
